/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

// loader css is in index
export function SpinnerCircle() {
  return <div className="loader"></div>;
}
